import { useCookies } from 'vue3-cookies'
const { cookies } = useCookies();
const fingerprintCookies = import.meta.env.VITE_FINGERPRINT_COOKIES

class ErrorHandlerService {
  constructor() {
    this.contextGetter = null
  }

  setContextGetter(callback) {
    this.contextGetter = callback
  }

  getDynamicContext() {
    try {
      const context = this.contextGetter ? this.contextGetter() : {};
      // Remove null or undefined values
      if (context && typeof context === 'object') {
        return Object.fromEntries(
          Object.entries(context).filter(([_, v]) => v !== null && v !== undefined)
        );
      }
      return {};
    } catch (error) {
      return {};
    }
  }

  buildPayload(error, extra = {}) {
    return {
      type: extra.type || 'unknown-error',
      message: error?.message || 'Unknown error',
      stack: error?.stack,
      page: window.location.pathname,
      fullUrl: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      fingerprintId: cookies.get(fingerprintCookies),
      ...this.getDynamicContext(),
      ...extra,

    }
  }

  send(error, extra = {}) {
    const finalError = error instanceof Error
      ? error
      : new Error(typeof error === 'string' ? error : 'Unknown error')
    const payload = this.buildPayload(finalError, extra)
    // console.error('[Datadog Error Handler]', finalError)

    try {
      if (window.DD_RUM?.addError) {
        window.DD_RUM.addError(finalError, payload)
      }
    } catch (rumError) {
      console.error('DD_RUM.addError failed', rumError)
    }

    try {
      if (window.DD_LOGS?.getLogger) {
        window.DD_LOGS.getLogger('storefront').error(
          finalError.message,
          payload,
          finalError,
        )
      }
    } catch (logError) {
      console.error('DD_LOGS logger failed', logError)
    }
  }
}

export const errorHandler = new ErrorHandlerService()